/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Enter_Your_NameInputs */

const en_common_enter_your_name = /** @type {(inputs: Common_Enter_Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your name`)
};

const es_common_enter_your_name = /** @type {(inputs: Common_Enter_Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu nombre`)
};

/**
* | output |
* | --- |
* | "Enter your name" |
*
* @param {Common_Enter_Your_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_enter_your_name = /** @type {((inputs?: Common_Enter_Your_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Enter_Your_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_enter_your_name(inputs)
	return en_common_enter_your_name(inputs)
});